import { render, staticRenderFns } from "./BundleProductSelector.vue?vue&type=template&id=7db3e227&"
import script from "./BundleProductSelector.vue?vue&type=script&lang=ts&"
export * from "./BundleProductSelector.vue?vue&type=script&lang=ts&"
import style0 from "./BundleProductSelector.vue?vue&type=style&index=0&id=7db3e227&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports